import { DependencyList, useEffect } from "react";
import useAsyncCallback from "./useAsyncCallback";
import { useTransformToRef } from "./useTransformToRef";

/**
 *
 * @param asyncFunction Função assíncrona que será executada no useEffect.
 * @param args - argumentos para serem passados na chamada da asyncFunction
 * @returns execute - função assíncrona com tratmentos de estados (sem parâmetros)
 * @returns executeEffect - função assíncrona com tratmentos de estados (com parâmetros)
 * @returns status - da requisição
 * @returns value - resultado da requisição
 * @returns error - erro encontrado no meio da requisição
 */
export default function useAsyncEffect<T, E = any>(
    asyncFunction: () => Promise<T>,
    deps?: DependencyList
) {
    const _deps = deps ?? [];
    const { execute, status, value, error, loading } = useAsyncCallback<T, E>(
        asyncFunction,
        _deps
    );
    // cria um callback com a função execute,
    // com a diferença de não ter parâmetro
    // (os parâmetros passados em args são
    // automaticamente passado para a função original)

    const executeRef = useTransformToRef(execute);

    useEffect(() => {
        executeRef.current();
        // eslint-disable-next-line react-hooks/exhaustive-deps -- precisa desabilitar porque o eslint não consegue detectar por causa do spread
    }, [executeRef, ..._deps]);

    return { execute, originalExecute: execute, status, value, error, loading };
}
